<template>
  <v-flex xs12 sm8 md4>
    <v-layout column align-center fill-height>
      <v-flex style="width:100%;">
        <v-card v-if="eventUid" class="elevation-5">
          <v-card-text>
            <div class="body-1 card-title-text">
              Введите новый пароль для Вашей учетной записи и нажмите на кнопку &quot;Сменить пароль&quot;
            </div>
            <v-form ref="form" v-model="formValid">
              <v-text-field autocomplete="new-password" v-model="newPassword" prepend-icon="mdi-lock" name="password" label="Новый пароль" type="password" :rules="[rules.required]"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat :disabled="!formValid" @click.stop="changePassword()">Сменить пароль</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else class="elevation-5">
          <v-card-text>
            <div v-if="sent" class="body-1 card-title-text">Письмо со ссылкой для смены пароля отправлено на адрес <b>{{ sentEmail }}</b>. Для продолжения проверьте Ваш почтовый ящик и перейдите по ссылке, указанной в письме.<br/>Для повторной отправки введите Ваш электронный адрес и нажмите "Отправить" снова.
            </div>
            <div v-else class="body-1 card-title-text">Для продолжения необходимо ввести адрес электронной почты, указанный при регистрации. Нажмите "Отправить" чтобы отправить письмо с ссылкой для смены пароля</div>
            <v-form id="form" ref="form" v-model="formValid">
              <v-text-field ref="email" v-model="email" prepend-icon="mdi-email-outline" name="mail" label="E-mail" type="email" :rules="[rules.required, rules.email]"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat :disabled="sentButtonDisabled"  @click.stop="sendForgotPasswordMessage()">Отправить
              <span v-if="sentTimeout">&nbsp;({{ sentTimeout }})</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex style="margin-top:14px;">
        <span style="margin-right:6px;">Другая учетная запись?</span>
        <a @click.stop="$router.push('/login')">Войти</a>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
  import Rules from "../rules.js"

  export default {
    name: 'forgotPassword',
    props: ['eventUid'],
    data: function() {
      return {
        formValid: false,
        newPassword: "",
        email: "",
        sent: false,
        sentEmail: "",
        sentTimeout: 0,
        rules: Rules
      }
    },
    computed: {
      sentButtonDisabled() {
        return (!this.formValid) || (this.sentTimeout > 0);
      }
    },
    mounted() {
      if (this.eventUid) {
        //this.confirmEmailValidationEvent();
      } else {
        if (this.$store.state.account) {
          this.email = this.$store.state.account.email;
        }
        setInterval(() => {
          if (this.sentTimeout) {
            this.sentTimeout--;
          }
        }, 1000);
      }
    },
    methods: {
      async sendForgotPasswordMessage() {
        if (await this.$store.dispatch("sendForgotPasswordMessage", { email: this.email })) {
          this.sentEmail = this.email;
          this.sentTimeout = 20;
          this.sent = true;
        }
      },
      async changePassword() {
        if (await this.$store.dispatch("changePassword", { eventUid: this.eventUid, newPassword: this.newPassword })) {
          this.$router.replace("/");
        }
      },
    }
  }
</script>

<style scoped>
  .card-title-text {
    text-align: justify;
    margin-bottom: 24px;
  }

</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?9c716382